import React from 'react'
import { FieldGroup, LabeledToggleRow, SettingsPane, ToggleList } from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const LeavePane: React.FC<OrganizationSettingsFormProps> = ({
  setValue,
  watch,
  disabled = false,
}) => (
  <SettingsPane
    title="Leave"
    description="Who signs off on time off, and whether balances may go negative."
  >
    <FieldGroup label="Approval workflow">
      <ToggleList>
        <LabeledToggleRow
          label="Require HR approval"
          description="Route leave requests through HR before final sign-off."
          checked={watch('leaveSettings.requireHRApproval') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('leaveSettings.requireHRApproval', checked, { shouldDirty: true })
          }
        />
        <LabeledToggleRow
          label="Require admin final approval"
          description="An admin must confirm at the end of the workflow."
          checked={watch('leaveSettings.requireAdminFinalApproval') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('leaveSettings.requireAdminFinalApproval', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>

    <FieldGroup label="Balances">
      <ToggleList>
        <LabeledToggleRow
          label="Allow negative leave balance"
          description="Staff may request leave beyond their accrued balance."
          checked={watch('leaveSettings.allowNegativeBalance') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('leaveSettings.allowNegativeBalance', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

LeavePane.displayName = 'LeavePane'
